module.exports = __webpack_public_path__ + "img/about_pic5.f8c9e6d3.jpg";